import React from 'react';
import './index.scss';

interface TagProps {
  /** 标签文本 */
  children: React.ReactNode;
  /** 是否可关闭 */
  closable?: boolean;
  /** 关闭回调 */
  onClose?: () => void;
  /** 自定义类名 */
  className?: string;
  /** 自定义样式 */
  style?: React.CSSProperties;
  /** 标签颜色类型 */
  color?: 'default' | 'primary' | 'success' | 'warning' | 'error';
  /** 标签大小 */
  size?: 'small' | 'medium' | 'large';
}

const Tag: React.FC<TagProps> = ({
  children,
  closable = false,
  onClose,
  className = '',
  style,
  color = 'default',
  size = 'medium'
}) => {
  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose?.();
  };

  const tagClass = [
    'custom-tag',
    `custom-tag--${color}`,
    `custom-tag--${size}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={tagClass} style={style}>
      <span className="custom-tag__text">{children}</span>
      {closable && (
        <span className="custom-tag__close" onClick={handleClose}>
          ×
        </span>
      )}
    </span>
  );
};

export default Tag;
